import b, { createContext as E, forwardRef as P, useContext as h, useEffect as N } from "react";
import { c as m, u as S } from "./useKeyDown-88662051.mjs";
const u = E({
  isInsideBlock: !1
}), B = "block__content", _ = "block__content--flex", v = "block__content--grid", x = "block__content--limited-width", A = "desktop", T = "desktop--limited-width", G = "debug", r = {
  blockContent: B,
  blockContentFlex: _,
  blockContentGrid: v,
  blockContentLimitedWidth: x,
  desktop: A,
  desktopLimitedWidth: T,
  debug: G
}, R = P(function(o, d) {
  const {
    children: e,
    limitedWidth: n = !0,
    className: c,
    style: l,
    id: s,
    debug: a,
    itemScope: k = !1,
    itemType: L,
    flex: C
  } = o;
  if (!h(u).isInsideBlock)
    throw new Error("Content should be only used inside the Block.");
  const f = a && process.env.NODE_ENV === "development" ? "debug" : "";
  return /* @__PURE__ */ b.createElement(
    "div",
    {
      ref: d,
      className: m(
        c,
        r.blockContent,
        f,
        n && r.blockContentLimitedWidth,
        C ? r.blockContentFlex : r.blockContentGrid
      ),
      style: l,
      id: s,
      itemScope: k,
      itemType: L
    },
    e
  );
}), y = "block", w = "block--padding-top-large", W = "desktop", I = "block--padding-top-small", D = "block--padding-top-small--disabled", M = "block--padding-bottom-large", O = "block--padding-bottom-small", i = {
  block: y,
  blockPaddingTopLarge: w,
  desktop: W,
  blockPaddingTopSmall: I,
  blockPaddingTopSmallDisabled: D,
  blockPaddingBottomLarge: M,
  blockPaddingBottomSmall: O
};
var g = /* @__PURE__ */ ((t) => (t.NONE = "NONE", t.SMALL = "SMALL", t.LARGE = "LARGE", t))(g || {});
function p(t) {
  const {
    children: o,
    className: d,
    topPadding: e = "LARGE",
    bottomPadding: n = "LARGE",
    as: c,
    blockRef: l,
    ...s
  } = t, a = c || "div";
  return /* @__PURE__ */ b.createElement(
    a,
    {
      className: m(
        i.block,
        F(e),
        K(n),
        d
      ),
      ...s,
      ref: l
    },
    /* @__PURE__ */ b.createElement(u.Provider, { value: { isInsideBlock: !0 } }, o)
  );
}
p.Content = R;
p.Padding = g;
function F(t) {
  return t === "LARGE" ? i.blockPaddingTopLarge : t === "SMALL" ? i.blockPaddingTopSmall : "";
}
function K(t) {
  return t === "LARGE" ? i.blockPaddingBottomLarge : t === "SMALL" ? i.blockPaddingBottomSmall : "";
}
function j(t, o, d = {}) {
  const { disabled: e = !1, enableEscKey: n = !0 } = d;
  S("Escape", o, { disabled: e || !n }), N(() => {
    if (e)
      return;
    const c = (l) => {
      const s = l.target;
      t.some(
        (k) => k.current?.contains(s)
      ) || (l.stopPropagation(), o());
    };
    return document.addEventListener("click", c), () => {
      document.removeEventListener("click", c);
    };
  }, [o, t, e, n]);
}
export {
  p as B,
  g as a,
  j as u
};
//# sourceMappingURL=useClickOutside-55c64a80.mjs.map
